import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Col, Row, Button } from 'react-bootstrap';

const body = (bodyText) => {
  if (bodyText) {
    return (
      <Modal.Body>
        {bodyText}
      </Modal.Body>
    );
  }
};

const ConfirmationModalComponent = ({
  visible,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  bodyText,
  title,
  eventProps,
}) => (
  <Modal onHide={onCancel} show={visible}>
    <Modal.Header closeButton>
      <Modal.Title>
        {title}
      </Modal.Title>
    </Modal.Header>
    {body(bodyText)}
    <Modal.Footer>
      <Row>
        <Col md={6}>
          <Button
            id="submit-button"
            bsStyle="warning"
            block
            onClick={() => onConfirm(eventProps)}
          >
            {confirmText}
          </Button>
        </Col>
        <Col md={6}>
          <Button block onClick={onCancel}>
            {cancelText}
          </Button>
        </Col>
      </Row>
    </Modal.Footer>
  </Modal>
);


ConfirmationModalComponent.propTypes = {
  visible: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  bodyText: PropTypes.string,
  eventProps:PropTypes.object,
};

export default ConfirmationModalComponent;



// WEBPACK FOOTER //
// src/Components/ConfirmationModalComponent.jsx